import {Component, OnInit} from '@angular/core';
import {DashboardService} from '../dashboard.service';
import {UtilsService} from '../../core/services/utils/utils.service';

@Component({
    selector: 'app-entities',
    templateUrl: './entities.component.html',
    styleUrls: ['./entities.component.css'],
    standalone: false
})

export class EntitiesComponent implements OnInit {

  users = [];
  filters = {
    keyword: '',
    category: 'all',
    inPerson: 'all',
    sortBy: 'created_desc'
  };
  categories: Array<{ id: string; categoryName: string }> = [];
  categoryNameMap: Record<string, string> = {};
  loading = true;
  loaders = Array(10).fill(0);

  // pagination
  page = 1;
  perPage = 20;
  total: number;

  constructor(
    private dashboardService: DashboardService,
    private utils: UtilsService,

  ) {
  }

  ngOnInit(): void {
    this.loading = true;
    this.getAllCategories();
    this.getAllEntities();
  }

  buildEntitiesPayload(page: number = 1): any {
    const payload: any = {
      page,
      per_page: this.perPage,
      sort_by: this.filters.sortBy
    };

    const keyword = (this.filters.keyword || '').trim();
    if (keyword) {
      payload.keyword = keyword;
    }

    if (this.filters.category !== 'all') {
      payload.category = this.filters.category;
    }

    if (this.filters.inPerson !== 'all') {
      payload.in_person = this.filters.inPerson;
    }

    return payload;
  }

  getAllEntities(newPage: number = this.page): void {
    this.page = newPage;
    this.loading = true;
    this.dashboardService.readAllEntities(this.buildEntitiesPayload(newPage)).subscribe((data) => {
      this.users = data.response.entities;
      this.total = data.response.totalCount;
      this.loading = false;
      window.scrollTo(0, 0);
    }, (err => {
      this.utils.resErr(err);
      this.loading = false;
    }));
  }

  pageChange(event): void {
    this.page = event;
    this.getAllEntities(event);
  }

  remove(id): void {
    if (confirm('Are you sure, you want ot DELETE this entity ?')){
      this.dashboardService.deleteEntity(id).subscribe((data) => {
        this.getAllEntities(this.page);
      });
    }
  }

  getAllCategories(): void {
    this.dashboardService.getAllCategories('').subscribe(res => {
      const payload = res?.response || res?.data || res;
      const rawCategories = Array.isArray(payload)
        ? payload
        : (Array.isArray(payload?.categories) ? payload.categories : []);

      const normalized = rawCategories
        .map((cat: any) => {
          const id = String(cat?.id || cat?._id || '').trim();
          const categoryName = String(cat?.categoryName || cat?.name || cat?.slug || '').trim();
          return id ? {id, categoryName} : null;
        })
        .filter((cat: any) => !!cat?.id && !!cat?.categoryName);

      this.categories = [{categoryName: 'All', id: 'all'}, ...normalized];
      this.categoryNameMap = normalized.reduce((acc: Record<string, string>, cat: any) => {
        acc[String(cat.id)] = cat.categoryName;
        return acc;
      }, {});
    }, err => this.utils.resErr(err));
  }

  getCategoryName(category: any): string {
    if (!category) {
      return '';
    }

    if (typeof category === 'string') {
      return this.categoryNameMap[category] || category;
    }

    const categoryId = String(category?.id || category?._id || '').trim();
    if (category?.categoryName) {
      return category.categoryName;
    }
    if (category?.name) {
      return category.name;
    }
    if (categoryId && this.categoryNameMap[categoryId]) {
      return this.categoryNameMap[categoryId];
    }
    return '';
  }

  handleCopyToClipboard(str: any = ''): void {
    this.utils.copyToClipboard(str);
    this.utils.toastSuccess('ID copied to your clipboard successfully');
  }

  applyFilters(): void {
    this.getAllEntities(1);
  }

  clearFilters(): void {
    this.filters = {
      keyword: '',
      category: 'all',
      inPerson: 'all',
      sortBy: 'created_desc'
    };
    this.getAllEntities(1);
  }

  hasActiveFilters(): boolean {
    return !!(this.filters.keyword || '').trim()
      || this.filters.category !== 'all'
      || this.filters.inPerson !== 'all'
      || this.filters.sortBy !== 'created_desc';
  }

  handleFilterInputKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.applyFilters();
    }
  }

}
